export default "__VITE_ASSET__51907672__"